import React, { useState, useEffect } from "react";
import {Modal, Button, Skeleton, Table, Descriptions} from "antd";
import * as taskInvoiceActions from "../../../../../../redux/actions/task.invoice.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {useParams} from "react-router-dom";

const InvoiceDetails = (props) => {

  const params = useParams();
  const { overviewdashboardid } = params;
  const [loading, setLoading] = useState(true);

  const taskInvoiceDataRefresh = async () => {
    try {
      await props.taskInvoiceActions.getTaskInvoiceDataAction(overviewdashboardid);
    } catch (e) {} finally {
      setLoading(false);
    }
  };

  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    if (props.visible && !hasLoaded) {
      setLoading(true);
      taskInvoiceDataRefresh().then(() => {
        setHasLoaded(true);
      });
    }

    if (!props.visible && hasLoaded) {
      setHasLoaded(false); // reset so it can load again next open
    }
  }, [props.visible]);

  const orderDetailColumns = [
    { title: "#", dataIndex: "key", key: "key", },
    { title: "Pr_id", dataIndex: "product_id", key: "product_id", },
    {
      title: "Images",
      render: (image) => {return image?(<img alt="Profile Image" src={image} />):(<Skeleton.Image active />)},
      dataIndex: "image",
      key: "image",
    },
    { title: "Product", dataIndex: "name", key: "name",  },
    { title: "Barcode", dataIndex: "barcode", key: "barcode", render: (value) => ( value || "null" )},
    { title: "Dimensions", dataIndex: "dimension", key: "dimension", render: (value) => ( value || "null" )},
    { title: "Quantity", dataIndex: "quantity", key: "quantity"},
    { title: "Price", dataIndex: "price", key: "price", },
    { title: "Total Price", dataIndex: "total_price", key: "total_price" },
  ];

  const handleCancel = () => {props.setvisible(false)};

  const username =
    props.orderData &&
    props.orderData[0] &&
    props.orderData[0].delivery &&
    props.orderData[0].delivery.username
      ? props.orderData[0].delivery.username
      : "-";


  const dynamics_invoice =
    props.taskInvoiceDetailData &&
    props.taskInvoiceDetailData.dynamics_invoice
      ? props.taskInvoiceDetailData.dynamics_invoice
      : [];

  const rawItems =
    dynamics_invoice.order_item_invoice_details
      ? dynamics_invoice.order_item_invoice_details
      : [];

  const filteredItems = rawItems.map((item, index) => ({
    ...item,
    key: index + 1
  }));

  return (
    <Modal
      title="Order Invoice"
      visible={props.visible}
      onCancel={handleCancel}
      width={"75%"}
      footer={[
        <Button onClick={handleCancel}>Cancel</Button>,
      ]}
    >
      <Descriptions
        className="listLabelBold"
        style={{ marginBottom: "35px" }}
        labelStyle={{ fontWeight: "500", flex: "0.20 1" }}
        size="small"
      >
        <Descriptions.Item label="Invoice To" span={3}>{username}</Descriptions.Item>
        <Descriptions.Item label="Invoice Date" span={3}>{dynamics_invoice?.created_at || "-"}</Descriptions.Item>
        <Descriptions.Item label="Invoice Number" span={3}>{dynamics_invoice?.id || "-"}</Descriptions.Item>
        <Descriptions.Item label="D365 Invoice ID" span={3}>{dynamics_invoice?.d365_invoice_id || "-"}</Descriptions.Item>
        <Descriptions.Item label="Address" span={3}>{dynamics_invoice?.complete_address || "-"}</Descriptions.Item>
        <Descriptions.Item label="Order Number" span={3}>{dynamics_invoice?.order_id || "-"}</Descriptions.Item>
      </Descriptions>
      <Table
        dataSource={filteredItems}
        columns={orderDetailColumns}
        pagination={false}
        summary={() => (
          <>
          <Table.Summary.Row>
            <Table.Summary.Cell index={0} colSpan={5} />
            <Table.Summary.Cell index={1} colSpan={3}><span style={{fontWeight: 600}}>Total Quantity</span></Table.Summary.Cell>
            <Table.Summary.Cell index={2}>{dynamics_invoice.total_qty || "-"}</Table.Summary.Cell>
          </Table.Summary.Row>
            <Table.Summary.Row>
              <Table.Summary.Cell index={3} colSpan={5} />
              <Table.Summary.Cell index={4} colSpan={3}><span style={{fontWeight: 600}}>Subtotal</span></Table.Summary.Cell>
              <Table.Summary.Cell index={5}>{dynamics_invoice.subtotal || "-"}</Table.Summary.Cell>
            </Table.Summary.Row>
            <Table.Summary.Row>
              <Table.Summary.Cell index={3} colSpan={5} />
              <Table.Summary.Cell index={4} colSpan={3}><span style={{fontWeight: 600}}>Additional Cost</span></Table.Summary.Cell>
              <Table.Summary.Cell index={5}>
                {dynamics_invoice && dynamics_invoice.additional_charges
                  ? JSON.parse(dynamics_invoice.additional_charges).map((item, index, arr) => (
                    <span
                      key={index}
                      style={{
                        display: 'block',
                        paddingBottom: '4px',
                        marginBottom: '4px',
                        borderBottom: index !== arr.length - 1 ? '1px solid #f0f0f0' : 'none',
                      }}
                    >
                      {index + 1} - {item.message} = {item.amount}
                    </span>
                  ))
                  : '-'}
              </Table.Summary.Cell>
            </Table.Summary.Row>
            <Table.Summary.Row>
              <Table.Summary.Cell index={3} colSpan={5} />
              <Table.Summary.Cell index={4} colSpan={3}><span style={{fontWeight: 600}}>Additional Info</span></Table.Summary.Cell>
              <Table.Summary.Cell index={5}>{dynamics_invoice.additional_info || "-"}</Table.Summary.Cell>
            </Table.Summary.Row>
            <Table.Summary.Row>
              <Table.Summary.Cell index={3} colSpan={5} />
              <Table.Summary.Cell index={4} colSpan={3}><span style={{fontWeight: 600}}>Wallet Amount Used</span></Table.Summary.Cell>
              <Table.Summary.Cell index={5}>-</Table.Summary.Cell>
            </Table.Summary.Row>
            <Table.Summary.Row>
              <Table.Summary.Cell index={3} colSpan={5} />
              <Table.Summary.Cell index={4} colSpan={3}><span style={{fontWeight: 600}}>Total Amount</span></Table.Summary.Cell>
              <Table.Summary.Cell index={5}>{dynamics_invoice.amount || "-"}</Table.Summary.Cell>
            </Table.Summary.Row>
          </>
          )}
      />
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    taskInvoiceDetailData: state.TaskInvoiceReducer.taskInvoiceDetailData,
    emailUser: state.authReducer.user,
    permissions: state.PermissionReducer.permissions,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    taskInvoiceActions: bindActionCreators(taskInvoiceActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceDetails);
